import { render } from "./MFITTBookingSelectSeatDivision.vue?vue&type=template&id=47dba066&scoped=true"
import script from "./MFITTBookingSelectSeatDivision.vue?vue&type=script&lang=js"
export * from "./MFITTBookingSelectSeatDivision.vue?vue&type=script&lang=js"

import "./MFITTBookingSelectSeatDivision.vue?vue&type=style&index=0&id=47dba066&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47dba066"

export default script